import { Button, Form } from "antd";
import FormItem from "antd/es/form/FormItem";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import PropTypes from "prop-types";
import useToast from "../../../hooks/userToast";

UpdateStudyDescription.propTypes = {
  studyDesc: PropTypes.string,
  studyPrimaryKey: PropTypes.number,
  fetchData: PropTypes.func,
  handleOk: PropTypes.func,
};

function UpdateStudyDescription({
  studyDesc,
  studyPrimaryKey,
  fetchData,
  handleOk,
}) {
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({
    studyDesc: studyDesc,
    initialValues: studyPrimaryKey,
  });
  // console.log(studyDesc, studyPrimaryKey);
  const { toastError, toastSuccess } = useToast();

  const handleSubmit = async (values) => {
    // console.log("values", values);
    try {
      const formData = {
        history_description: values.studyDesc, // Capture the input from the form
      };
      await apiClient.patch(`studyInfo/${studyPrimaryKey}`, formData);
      await toastSuccess("Study Description Updated Successfully");
      await handleOk();
      await fetchData();
      form.resetFields();
    } catch (error) {
      toastError("Error Updating Study Description", error);
      console.log(error);
    }
  };

  useEffect(() => {
    setInitialValues({ studyDesc });
    form.setFieldsValue({ studyDesc });
  }, [studyPrimaryKey]);
  return (
    <div>
      <Form onFinish={handleSubmit} initialValues={initialValues} form={form}>
        <FormItem
          name="studyDesc"
          rules={[{ required: true, message: "Required" }]}
        >
          <TextArea autoSize={{ minRows: 2, maxRows: 8 }} />
        </FormItem>
        <div className="d-flex justify-content-center my-2">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default UpdateStudyDescription;
